/**
 * This is the i18n configuration
 *
 * See https://www.i18next.com/configuration-options.html
 */

// Same base as the other API calls (config/apiConfig.js). A relative path
// ("api/public/getLocales") is resolved against the page URL and breaks when the
// app is served under a sub path (ex: /app/ on the Go server -> /app/api/... = 404)
var serverUrl = require("./apiConfig").serverUrl.replace(/\/$/, "") ;

module.exports = { backend: { loadPath: serverUrl + '/api/public/getLocales?lang={{lng}}'}} ;
